<template>
  <div class="reviewPostButtonsArea pc">
    <div class="button buttonReviewPost" @click="showModal()"><span>投稿する</span></div>
  </div>
  <div class="reviewPostButtonsArea sp">
    <div class="button buttonReviewMenu" @click="showModal()"><span></span></div>
  </div>
  <div class="form formSignupAppeal" v-if="show" @click.self="closeModal">
    <div class="box">
      <div class="contents">
        <div class="signupAppeal">
          <h3>
            <slot></slot>
          </h3>
          <div class="next">
            <a class="button" href="/register">登録へ進む</a>
            <a class="textLink" href="/login">アカウントをお持ちの方はこちら</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  methods: {
    showModal() {
      this.show = true;
    },
    closeModal() {
      this.show = false;
    },
  },
};
</script>
